import { StockBalanceList, StockMovementList, StockMovementResponse, StockTransferResponse, } from '@aeris/contracts';
import { request } from "./client.js";
/**
 * `/api/v1/inventory` — o razão de movimentos e o saldo derivado dele.
 *
 * Toda quantidade atravessa esta fronteira como STRING, no formato de máquina.
 * O formulário lê o que a pessoa digitou — `1.234,5` — com @aeris/money e
 * serializa o valor exato aqui; um número JSON seria arredondado pelo
 * navegador antes mesmo de a requisição existir.
 */
/**
 * Built field by field, like the catalogue's. Same reason: iterating gives
 * `unknown` values that would stringify blindly.
 */
export const balanceParams = (query) => {
    const params = new URLSearchParams();
    if (query.branchId !== undefined)
        params.set('branchId', query.branchId);
    if (query.search !== undefined && query.search.length > 0) {
        params.set('search', query.search);
    }
    /*
     * A marca e o modo de busca também não saíam daqui (F182).
     *
     * O select "Todas as marcas" e o par "Qualquer parte / Começa com" estavam na
     * tela do Estoque, o contrato os declarava e a rota os aplicava — só que o
     * cliente nunca os escrevia na URL. Escolher uma marca não mudava uma linha
     * da lista.
     */
    if (query.searchMode !== undefined)
        params.set('searchMode', query.searchMode);
    if (query.brand !== undefined && query.brand.length > 0) {
        params.set('brand', query.brand);
    }
    if (query.productId !== undefined)
        params.set('productId', query.productId);
    if (query.onlyWithStock !== undefined) {
        params.set('onlyWithStock', query.onlyWithStock ? 'true' : 'false');
    }
    if (query.negative !== undefined) {
        params.set('negative', query.negative ? 'true' : 'false');
    }
    if (query.belowMinimum !== undefined) {
        params.set('belowMinimum', query.belowMinimum ? 'true' : 'false');
    }
    if (query.categoryId !== undefined) {
        params.set('categoryId', query.categoryId);
    }
    if (query.page !== undefined)
        params.set('page', String(query.page));
    if (query.pageSize !== undefined) {
        params.set('pageSize', String(query.pageSize));
    }
    if (query.sort !== undefined)
        params.set('sort', query.sort);
    if (query.direction !== undefined)
        params.set('direction', query.direction);
    const encoded = params.toString();
    return encoded.length > 0 ? `?${encoded}` : '';
};
export const fetchStockBalances = async (query, signal) => StockBalanceList.parse(await request(`/api/v1/inventory/balances${balanceParams(query)}`, {
    signal,
}));
export const fetchStockMovements = async (query, signal) => {
    const params = new URLSearchParams({ variantId: query.variantId });
    if (query.branchId !== undefined)
        params.set('branchId', query.branchId);
    if (query.page !== undefined)
        params.set('page', String(query.page));
    if (query.pageSize !== undefined) {
        params.set('pageSize', String(query.pageSize));
    }
    return StockMovementList.parse(await request(`/api/v1/inventory/movements?${params.toString()}`, {
        signal,
    }));
};
/**
 * Quantities go up as strings, in the machine format.
 *
 * The form parses what a person typed — `1.234,5` — with @aeris/money and
 * serialises the exact value here. A JSON number would be rounded by the
 * browser before the request was even built.
 */
export const recordStockEntry = async (input) => StockMovementResponse.parse(await request('/api/v1/inventory/entries', { method: 'POST', body: input }));
export const recordStockExit = async (input) => StockMovementResponse.parse(await request('/api/v1/inventory/exits', { method: 'POST', body: input }));
export const adjustStock = async (input) => StockMovementResponse.parse(await request('/api/v1/inventory/adjustments', {
    method: 'POST',
    body: input,
}));
export const transferStock = async (input) => StockTransferResponse.parse(await request('/api/v1/inventory/transfers', {
    method: 'POST',
    body: input,
}));
//# sourceMappingURL=inventory.js.map